import {
  ProcessedCustomSectionItem,
  ProcessedSystemSectionItem,
  SidebarMenuItemProps,
} from '../../../types';
import { SidebarMenu } from '../SidebarMenu';

type SidebarSectionItemProps =
  | SidebarMenuItemProps<ProcessedSystemSectionItem['type']>
  | SidebarMenuItemProps<ProcessedCustomSectionItem['type']>;

export const SidebarSectionItem = ({ item }: SidebarSectionItemProps) => {
  return <SidebarMenu menuLabel={item.title} items={item.children} />;
};
